import { getDay, getWeekOfMonth, startOfMonth } from 'date-fns';
import {
	CreateScheduleRepeat,
	DaysOfWeekEnum,
	isDayOfLastWeekOfMonth,
	ScheduleRepeatTypesEnum,
} from '@sweatpals/shared';
import { DaysOfWeek } from './days-of-week.constants';

const getDayOfWeekId = (date: Date): DaysOfWeekEnum => {
	const day = getDay(date);

	switch (day) {
		case 1:
			return DaysOfWeekEnum.Monday;
		case 2:
			return DaysOfWeekEnum.Tuesday;
		case 3:
			return DaysOfWeekEnum.Wednesday;
		case 4:
			return DaysOfWeekEnum.Thursday;
		case 5:
			return DaysOfWeekEnum.Friday;
		case 6:
			return DaysOfWeekEnum.Saturday;
		default:
			return DaysOfWeekEnum.Sunday;
	}
};

export const getDefaultWeeklyRepeatValues = (startEventDate: Date): CreateScheduleRepeat => ({
	typeId: ScheduleRepeatTypesEnum.Weekly,
	interval: 1,
	dayOfWeekIds: [getDayOfWeekId(startEventDate)],
	endDate: undefined,
});

export const getDefaultMonthlyRepeatValues = (startEventDate: Date): CreateScheduleRepeat => ({
	typeId: ScheduleRepeatTypesEnum.Monthly,
	dayOfWeekIds: [DaysOfWeek[startEventDate.getDay()]?.id],
	weekOfMonth: isDayOfLastWeekOfMonth(startEventDate)
		? -1
		: getWeekOfMonth(startEventDate, {
				weekStartsOn: startOfMonth(startEventDate).getDay() as 0 | 1 | 2 | 3 | 5 | 6,
			}),
});

export const ScheduleRepeatOptions = [
	{ id: ScheduleRepeatTypesEnum.Weekly, label: 'Weekly' },
	{ id: ScheduleRepeatTypesEnum.Daily, label: 'Daily' },
	{ id: ScheduleRepeatTypesEnum.Monthly, label: 'Monthly' },
	{ id: ScheduleRepeatTypesEnum.Never, label: 'Never' },
];
